<template>
  <div
    class="w-1/3 p-1 h-28 float-left"
  >
    <div
      class="flex flex-col h-full items-center justify-center text-center cursor-pointer duration-300 transition p-1 rounded-lg leading-none relative select-none"
      :class="{
        'border border-white hover:bg-gray-100 hover:border-gray-roc': !config.active,
        'border-2 border-gray-roc bg-gray-roc bg-opacity-25': config.active,
      }"
      @click="toggleArtifactActive"
    >
      <span
        :style="{
          filter: `drop-shadow(0 0 10px ${shadowColor})`
        }"
      >
        <img
          :src="require(`@/assets/images/artifact/${artifact.icon}`)"
          alt=""
          class="w-6 h-6"
        />
      </span>

      <span class="text-sm leading-tight font-medium mt-3">
        {{ artifact.name }}<br />({{ artifact.power }})
      </span>
    </div>
  </div>
</template>

<script>
import {computed} from 'vue';

export default {
  props: {
    artifact: {
      type: Object,
      required: true
    },
    config: {
      type: Object,
      required: true
    }
  },
  emits: ['activate'],
  setup(props, context) {
    return {
      shadowColor: computed(() => {
        const value = props.artifact.power;
        if (value >= 50) return 'rgba(255, 0, 255, 1)';
        if (value >= 25) return 'rgba(0, 153, 255, 1)';
        if (value >= 10) return 'rgba(0, 255, 0, 1)';
        return 'rgba(0, 0, 0, 0)';
      }),
      myTitle: computed(() => {
        return props.config.active ? 'Deactivate' : 'Activate';
      }),
      toggleArtifactActive() {
        context.emit('activate', props.artifact.id);
      }
    };
  }
};
</script>
